// extracted by mini-css-extract-plugin
export default {"header":"CollapsibleTableCard_header__KOB-r","content":"CollapsibleTableCard_content__iJVmt","collapsed":"CollapsibleTableCard_collapsed__ZpwjX"};